// Copyright (C) 2020-2022 Intel Corporation
// Copyright (C) 2022-2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import Text from 'antd/lib/typography/Text';
import { Row, Col } from 'antd/lib/grid';
import Empty from 'antd/lib/empty';

import config from 'config';

export default function EmptyListComponent(): JSX.Element {
    return (
        <Empty
            className='cvat-empty-models-list'
            description={(
                <div>
                    <Row justify='center' align='middle'>
                        <Col>
                            <Text strong>还未部署任何模型...</Text>
                        </Col>
                    </Row>
                    <Row justify='center' align='middle'>
                        <Col>
                            <a href={`${config.NUCLIO_GUIDE}`}>使用 nuclio 部署模型</a>
                        </Col>
                    </Row>
                </div>
            )}
        />
    );
}
